export const H2H_PET_STATUS_LABELS = {
  PENDING: 'Pending',
  APPROVED: 'Published',
  REJECTED: 'Rejected',
  REMOVED: 'Removed',
  ADOPTED: 'Adopted',
  FOSTERED: 'Fostered',
  EXPIRED: 'Expired',
  SENT_TO_HQ: 'Under Review',
}

export type H2H_PET_STATUS = keyof typeof H2H_PET_STATUS_LABELS
